<template lang="pug">
  v-container.align-self-start.pa-0.ma-0
      v-snackbar( v-model="showSnackBar" :color="snackBarColor" ) {{snackBarText}}
          template( v-slot:action="{attrs}")
              v-btn(text v-bind="attrs" @click="showSnackBar = false")
                  v-icon fal fa-times fa-times-circle
      UserQrCode(v-if="showQrCode && showCustomerQrCode" :show="showQrCode" @close="closeQrDialog")
      RatingDialog(v-if="showDetailLastOrderClick && showRatingLastOrder" :show="showDetailLastOrderClick" @close="closeRatingDialog" :ratingDeliveryTimeData="ratingDeliveryTimeData"
                    :lastReservationDetailData="getReservationData" :selectedOfferRating="selectedOfferRating" @refreshData="refreshData")
      v-row.ma-0
          v-col.pa-0(cols="12")
              v-row.ma-0(no-gutters v-if="showRatingLastOrder && getReservationData && getReservationData.length > 0")
                  v-col.pa-0(cols="12" sm="12" md="6" lg="6")
                      v-card.pa-0.box2x( @click="onDetailLastOrderClick")
                          v-card-title {{ $t('ratingDialog.ratingOrderTitle') }} z {{getFormattedDate}}
                          v-card-text.pa-0
                              v-row.ma-0
                                  v-col.pa-0(cols="12")
                                      v-list.pa-0(v-for="(item,idx) in getReservationData" :key="idx")
                                          v-list-item.ma-0
                                              v-list-item-content
                                                  v-row.ma-0
                                                      v-col.pa-0.text-wrap(cols="12" v-for="(i,index) in item.reservedOffers" :key="index") {{i.dailyMenuOffer.referenceFoodItem.title}}...
                          v-card-actions.pa-0
                            v-row.ma-0
                                v-col.text-center.pr-0.pl-0(cols="12")
                                    v-btn(@click="onDetailLastOrderClick" text outlined )
                                        v-icon( @click="" color="success") fas fa-smile
                                        span.pl-1 {{ $t('ratingDialog.rateOrder') }}
              v-row.ma-0
                  v-col.pa-0(cols="12" sm="12" md="6" lg="6")
                      CurrentDailyMenu.box2x(:timeBlockCollection="timeBlockCollection" :settingsData="settingsData" :currentUser="currentUser")
                  v-col(v-if="shouldShowInvoiceWidget && timeBlockCollection && timeBlockCollection.length === 1" cols="12" sm="12" md="6" lg="6")
                      LatestInvoice.box2x
              v-row.ma-0
                  v-col(cols="12" sm="12" md="3" lg="3"  v-if="isMobile && showCustomerQrCode" align="center")
                      user-q-r
                  v-col(v-if="timeBlockCollection && timeBlockCollection.length === 1" v-for="(message, idx) in messages" :key="idx" cols="12" sm="12" md="3" lg="3")
                      Message.box2x.messageUrgent(:message="message")
                  v-col(cols="12" sm="12" md="3" lg="3" v-if="currentCreditBalance && timeBlockCollection && timeBlockCollection.length === 1")
                      v-card.box2x(@click="onCreditDetailsClick" min-height="250px")
                          v-card-title {{ $t('navigationItem.creditPageLabel') }}
                          v-card-subtitle
                          v-col.text-h3
                              v-row.pa-4
                                  v-spacer
                                  div.pb-0.pr-1.font-weight-bold(:class="getColor") {{formattedCurrentCreditBalance}}
                                  v-icon.font-weight-bold.ml-2(x-large :class="getColor") fal fa-euro-sign
                              v-row
                                  v-btn.text-decoration-underline.textClass.text-capitalize(text @click="onCreditDetailsClick" ) {{ $t('details')}}

      template(v-if="$vuetify.breakpoint.smAndDown && showCustomerQrCode")
          v-btn.mb-8.centered-button(color="primary" large @click="onQrCodeClick" bottom fixed dark)
            v-icon fal fa-qrcode
            span.pl-2 {{ $t('navigationItem.qrCodeLabel') }}
</template>

<script lang="ts">
import Vue from 'vue'
import Moment from 'moment'
import UserQR from '@/components/dashboard/UserQR.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import CurrentDailyMenu from '@/components/dashboard/CurrentDailyMenu.vue'
import {IS_MOBILE, USER_LOGGED_IN} from '@/store/getter-types'
import {CurrentUser} from '@/model/CurrentUser'
import {
  FETCH_DASHBOARD,
  FETCH_TENANT_NAME,
  USER_DAILY_MENU
} from '@/store/action-types'
import {DashboardMessage} from '@/types'
import Message from '@/components/dashboard/Message.vue'
import LatestInvoice from '@/components/dashboard/LatestInvoice.vue'
import {formatFloatPrice} from '@/services/formatter'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import UserQrCode from "@/components/dashboard/UserQrCode.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {TranslateResult} from "vue-i18n";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {RatingModel} from "@/model/RatingModel";
import moment from "moment";

@Component({
  components: {
    RatingDialog,
    UserQR,
    CurrentDailyMenu,
    Message,
    LatestInvoice,
    UserQrCode
  }
})
export default class DashboardPage extends Vue {
  private messages: DashboardMessage[] = []
  private currentCreditBalance: number | null = null
  private formattedCurrentCreditBalance: string = ''
  private timeBlockCollection: BusinessTimeBlockCollection[] | null = null
  private settingsData: any[] = []
  private showQrCode: boolean = false
  private showCustomerQrCode: boolean = false
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private piniaStore: any = usePiniaStore()
  private showDetailLastOrderClick: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] | null = []
  private showRatingLastOrder: boolean = false
  private selectedOfferRating: RatingModel | null = null
  private ratingDeliveryTimeData: number | null= null


  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser
  @Action(USER_DAILY_MENU) fetchDailyMenu!: ({ (payload: any): Promise<void> })
  @Action(FETCH_DASHBOARD) fetchDashboard!: ({ (): Promise<any> })


  get getFormattedDate():string {
    let date: string = ''
      this.getReservationData.forEach((i:any) => {
       date = moment(i.date).locale('sk').format('D.M.YYYY dddd')
    })
    return date
  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }

  get isMobile(): boolean {
    return this.$store.getters[IS_MOBILE]
  }

  get getColor(): any {
    if (this.currentCreditBalance && this.currentCreditBalance < 0) {
      return 'red--text'
    } else if (this.currentCreditBalance && this.currentCreditBalance > 0) {
      return 'green--text'
    } else {
      return 'black--text'
    }
  }

  get shouldShowInvoiceWidget(): boolean {
    const isEmployee = this.currentUser.boarderList.filter((b: any) => {
      return !!b.boarderGroupCollection.find((g: any) => g.name === 'zamestnanci')
    }).length === 1

    return !isEmployee;
  }

  closeRatingDialog(): void{
    this.showDetailLastOrderClick = false
  }

  refreshData(): void{
    this.showDetailLastOrderClick = false
    this.fetchData()
  }

  onDetailLastOrderClick(): void{
    this.showDetailLastOrderClick = true
  }

  onQrCodeClick(): void {
    this.showQrCode = true
  }

  closeQrDialog(): void {
    this.showQrCode = false
  }

  onCreditDetailsClick() {
    this.$router.push({name: 'Credit'})
  }

  async fetchData(): Promise<void> {
    this.lastReservationNumber = []
    this.fetchDailyMenu({
      from: Moment().format('Y-MM-DD'),
      to: Moment().add(1, 'days').format('Y-MM-DD'),
      user_id: this.currentUser.getBoarder?.id
    })

    const dashboard = await this.fetchDashboard()
    dashboard.offerReservationsToRate.forEach((item:any) => {
      this.selectedOfferRating = item.offerReservationRating
      this.lastReservationNumber!.push(item.offerReservation.id)
    })
    if(this.lastReservationNumber !== null) {
      this.fetchLatestOrderDetail()
    }

    this.currentCreditBalance = dashboard.currentCreditBalance
    this.formattedCurrentCreditBalance = formatFloatPrice(dashboard.currentCreditBalance)
    this.fetchTimeBlockData()


    this.messages = dashboard.messages
  }

  async fetchSettingsData(): Promise<void> {
    try {
      this.settingsData = await this.$store.dispatch(FETCH_TENANT_NAME)
    } catch (e) {
    } finally {
    }
  }

  async fetchTimeBlockData (): Promise<void> {
    try {
      this.timeBlockCollection = await this.piniaStore.fetchTimeBlocks()
    }catch (e) {
    }
  }

  async fetchCustomer(): Promise<void> {
    let payload: any = this.currentUser.boarderList[0].customer.id
    try {
      const response = await this.piniaStore.fetchCustomerQrConfiguration(payload)
      this.showCustomerQrCode = response.configuration.show_boarder_card || false
      this.showRatingLastOrder = response.configuration.allow_rating_last_order || false
      this.ratingDeliveryTimeData = response.configuration.last_order_rating_delivery_time_delta
    } catch (e) {
      this.showSnackBar = true
      this.snackBarText = this.$t('errors.fetchDataError').toString()
      this.snackBarColor = 'error'
    } finally {
    }
  }

  async fetchLatestOrderDetail(): Promise<void> {
    this.lastReservationDetailData = []
    try {
      const promises: Promise<any>[] = []
      this.lastReservationNumber!.forEach((number: number) => {
        let payload: any = number
        promises.push(this.piniaStore.fetchLastOrder(payload))
      })
      const responses = await Promise.all(promises)
        this.lastReservationDetailData.push(responses)
    } catch (e) {
    }
  }

  async created() {
    await this.fetchCustomer()
  }

  mounted(): void {
    this.fetchData()
    this.fetchSettingsData()

  }
}
</script>

<style lang="stylus" scoped>

.centered-button
  left: 50%
  transform: translate(-50%)

.box
  width 250px
  height 250px

.box2x
  margin 15px 15px 0
.textClass
  color blue

.messageUrgent
  font-size 1.2em
  background-color #fbd457
  text-align center

.mail
  padding 0
  margin 0

@media screen and (max-width: 960px)
  .boxes
    flex-direction column

</style>
